import { ObjectMapping } from "../../../model/object-mapping";
import { otsBaseApi } from "../../ots-api";
import { EntityIdentifier } from "../../../model/entity";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ['ObjectMappings']})

const objectMappingApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getObjectMappingsByObject: builder.query<ObjectMapping[], EntityIdentifier>(
      {
        query: (eo) => ({
          url: '/object-mappings/entity',
          method: 'GET',
          params: { id: eo.id, type: eo.type },
        }),
        providesTags: (result) => {
          if (result) {
            return [
              ...result.map(
                ({ id }) => ({ type: 'ObjectMappings', id } as const)
              ),
              { type: 'ObjectMappings', id: 'LIST' },
            ];
          } else {
            return [{ type: 'ObjectMappings', id: 'LIST' }];
          }
        },
      }
    ),
    getObjectMapping: builder.query<ObjectMapping, string>({
      query: (id) => ({
        url: `/object-mappings/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'ObjectMappings', id }],
    }),
    createObjectMapping: builder.mutation<void, Partial<ObjectMapping>>({
      query: (mapping) => ({
        url: '/object-mappings',
        method: 'POST',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: [{ type: 'ObjectMappings', id: 'LIST' }],
    }),
    updateObjectMapping: builder.mutation<void, Partial<ObjectMapping>>({
      query: (mapping) => ({
        url: '/object-mappings',
        method: 'PUT',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ObjectMappings', id },
      ],
    }),
    deleteObjectMapping: builder.mutation<void, Partial<ObjectMapping>>({
      query: (mapping) => ({
        url: `/object-mappings/${mapping.id}`,
        method: 'DELETE',
        body: mapping,
        responseHandler: () => Promise.resolve(),
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'ObjectMappings', id },
      ],
    }),
  }),
})

export const {
  useGetObjectMappingsByObjectQuery,
  useGetObjectMappingQuery,
  useCreateObjectMappingMutation,
  useUpdateObjectMappingMutation,
  useDeleteObjectMappingMutation,
} = objectMappingApi;
